import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../isLoading.slice';
import axios from 'axios';
import { logOut } from '../../../resources/utils';


export const formsSlice = createSlice({
    name: 'forms',
    initialState: {
        items: [],
        item: {},
        message: "",
        error: "",
    },
    reducers: {
        initialStateForm: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: "",
            }
        },
        setForms: (state, action) => {
            return {
                items: action.payload,
                item: {},
                message: "",
                error: "",
            }
        },
        setForm: (state, action) => {
            return {
                items: [],
                item: action.payload,
                message: "",
                error: "",
            }
        },
        setFormMessages: (state, action) => {
            return {
                items: [],
                item: {},
                message: action.payload,
                error: "",
            }
        },
        setFormError: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: action.payload,
            }
        },
    }
})

export const getFormsThunk = () => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/forms`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setForms(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setFormError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getFormThunk = (Form_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/forms/${Form_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setForm(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setFormError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const createFormThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.post(`/forms/createForm`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setFormMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setFormError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const updateFormThunk = (Form_id, data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/forms/updateForm/${Form_id}`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setFormMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setFormError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const deleteFormThunk = (Form_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.delete(`/forms/${Form_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setFormMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setFormError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const { 
    initialStateForm,
    setForms,
    setForm,
    setFormMessages,
    setFormError
} = formsSlice.actions;

export default formsSlice.reducer;